import type { ReactElement } from "react";

import image from "@/assets/holiday-cards/holiday-card-dad-jokes.png";
import { DayDefinition } from "../DayDefinition.js";
import RandomButton from "../shared/RandomButton.js";

/**
 * Class Dad_Jokes
 *
 * Represents the Dad Jokes card.
 */
export class Dad_Jokes extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-red2022";

	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "dad-jokes";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Winter Puns & Dad Jokes";
		this.content = <ENContent />;
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Calembours d`hiver et blagues de papa";
		this.content = <FRContent />;
	}
}

/**
 * English content for the Dad Jokes card.
 *
 * @returns The English content for the Dad Jokes card.
 */
function ENContent(): ReactElement {
	const puns = [
		`What do Santa’s little helpers learn at school?
			The elf-abet`,
		`How much did Santa pay for his sleigh?
			Nothin It was on the house.`,
		`What did one snowman say to the other?
			Do you smell carrots?`,
		`Who is a snowman’s favourite family member?
			Aunt Arctica`,
		`Why don’t you ever see Santa in the hospital?
			Because he has private elf care!`,
		`How do you know when Santa’s around?
			You can always sense his presents.`,
		`What kind of music do elves like?
			Wrap music`,
		`What do you get when you cross a snowman and a vampire?
			Frostbite.`,
		`How do you find Will Smith in the snow?
			You look for Fresh Prints!`,
		`Why did the boy keep his trumpet in the freezer?
			Because he liked cool music.`,
	];
	return (
		<>
			<p className="hl:whitespace-pre-line">
				{`Welcome, fellow pun master, bookmark this for when you feel like being funny
				A list of dad jokes, that are as bad just as they are punny
				We caution you though, you may get some eye rolls from these jokes
				But at the end of the day, you’ll be bringing a laugh to many folks`}
			</p>
			<RandomButton
				buttonTheme={`foliage`}
				content={puns}
				title={`Get another joke`}
			/>
		</>
	);
}

/**
 * French content for the Dad Jokes card.
 *
 * @returns The French content for the Dad Jokes card.
 */
function FRContent(): ReactElement {
	const puns = [
		`Pourquoi les elfes du Père Noël vont-ils à l'école ?
			Pour apprendre l’elfe-abet.`,
		`Pourquoi le Père Noël est-il si fort au karaté ?
			Parce qu'il porte une ceinture noire.`,
		`Que dit un bonhomme de neige à un autre ?
			Tu ne trouves pas que ça sent la carotte ?`,
		`Comment appelle-t-on un elfe qui porte un cache-oreilles ?
			Il n’entend rien, alors il vaut mieux aller le chercher.`,
		`Pourquoi ne voit-on jamais le Père Noël à l'hôpital ?
			Parce qu'il a une Santa de fer !`,
		`Qu'est-ce qui est vert, blanc et rouge ?
			Un lutin qui a attrapé un coup de soleil.`,
		`Quel est le plus gros défaut des elfes ?
			Ils s'emballent beaucoup trop !`,
		`Que cherche-t-on à éviter lorsqu’on croise un bonhomme de neige et un vampire ?
			D'être pris dans un froid mordant.`,
		`Monsieur et Madame Relande ont un fils. Comment s'appelle-t-il ?
			Guy.`,
		`Que craint un sapin s’il arrive en retard le soir de Noël ?
			De se faire enguirlander...`,
	];
	return (
		<>
			<p className="hl:whitespace-pre-line">
				{`Bienvenue aux amateurs de jeux de mots ! Voici de quoi faire le drôle.
					Des calembours aussi terribles que savoureux pour décrocher le premier rôle.
					Mais prenez garde : pour obtenir un fou rire général,
					Il vous faudra jouer de malice et vos blagues deviendront fatales !`}
			</p>
			<RandomButton
				buttonTheme={"foliage"}
				content={puns}
				title={"Découvrez nos meilleures vannes"}
			/>
		</>
	);
}
